module.exports = __webpack_public_path__ + "assets/webgl/Assets_2_base_color.jpg.6afa3596.webp";